import React from 'react';
import styled from 'styled-components';
import { SkeletonLine, SkeletonHeading, SkeletonChart } from '@finect/tabular-components/Skeleton';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { Side } from '@finect/tabular-core/Side';
const Inner = styled.div.withConfig({
  displayName: "FundSheetSkeleton__Inner",
  componentId: "sc-1uq39hf-0"
})(["display:block;"]);
export const FundSheetSkeleton = () => React.createElement(Inner, null, React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, null, React.createElement(SkeletonHeading, {
  h1: true
}), React.createElement(SkeletonLine, null), React.createElement("br", null), React.createElement("br", null), React.createElement(SkeletonLine, null), React.createElement("br", null), React.createElement(SkeletonLine, null), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement(SkeletonHeading, {
  h2: true
}), React.createElement(SkeletonChart, null)), React.createElement(Side, null, React.createElement(SkeletonChart, null)))));